<template>
  <div class="h-full">
    <div class="bg-light-yellow py-4 sm:px-4">
      <h1 class="mx-auto sm:w-full text-black w-[684px]">個人資訊</h1>
    </div>
    <section class="mx-auto my-10 sm:px-4 sm:w-full w-[684px]">
      <user-infos />
      <user-security class="my-10 sm:my-6" />
    </section>
  </div>
</template>

<script>
import User from './User';

export default User;
</script>

<style lang="scss" scoped>
@import 'User';
</style>
